import React, { useState, useEffect } from "react";
import axios from "axios";
import Highlighter from "react-highlight-words";
import "../../styles/veterinarycondistyles.css";
import Nav from "../veterinaryconditions/Nav";
import Banner from "../veterinaryconditions/Banner";
import { useHistory, Link } from "react-router-dom";
import Cookies from "js-cookie";
import config from "../../config/config";
import { autoSuggestQuery } from "../../openSearchQueries";
import { getSpecialtyInAutoSuggest } from "../../helper/AutoSuggestHelper";

const SearchBanner = () => {
  let history = useHistory();
  const [getApi, setFlag] = useState(false);
  const [url, setUrl] = useState("");
  const [searchkey, setSearchkey] = useState("");
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    let recentSearches =
      Cookies.get("searches") !== undefined
        ? Cookies.get("searches").split(",")
        : [];
    if (getApi) {
      axios
        .post(url, autoSuggestQuery(searchkey), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const setSuggestionList = async (suggestions) => {
              let optionsList = [];
              if (suggestions.length) {
                let suggestionWithSpecialty = await getSpecialtyInAutoSuggest(
                  suggestions
                );
                optionsList = (
                  <div className="autosuggest-container">
                    <ul className="options">
                      {recentSearches.length ? <p>Recent Searches</p> : ""}
                      {recentSearches.map((rs, index) => {
                        return (
                          <li key={rs} id={index}>
                            <Link to={"/topic-search/" + rs + "/Small Animals"}>
                              {rs}
                            </Link>
                          </li>
                        );
                      })}
                      <p>Topics</p>
                      {suggestionWithSpecialty.map((optionName, index) => {
                        return (
                          <li
                            key={optionName?.id}
                            id={recentSearches.length + index}
                          >
                            <Link
                              to={`/topic/${optionName?.spc[0]?.replace(
                                /[^a-zA-Z0-9]/g,
                                "-"
                              )}/${optionName?.id}`}
                            >
                              <Highlighter
                                highlightClassName="highlighted-text"
                                searchWords={[searchkey]}
                                autoEscape={true}
                                textToHighlight={optionName?.suggestion}
                              />
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              }
              setOptionList(optionsList);
            };
            setSuggestionList(response.data?.hits?.hits);
            setFlag(false);
          } else {
            throw new Error("Something went wrong ...");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [getApi, url, searchkey]);

  function changeSearchkey(srchkey) {
    srchkey = srchkey.replace(/[?;//]/g, " ");
    setSearchkey(srchkey);
    if (srchkey !== "") {
    const baseURL = `${config.BASE_URL}search`;
      let autoSuggestUrl = baseURL;

      setUrl(autoSuggestUrl);
      setFlag(true);
    } else {
      setOptionList([]);
    }
  }

  function setCookie(srchkey) {
    var recentValue =
      Cookies.get("searches") !== undefined
        ? Cookies.get("searches").split(",").reverse()
        : [];
    if (recentValue.indexOf(srchkey) > -1) {
      recentValue.splice(recentValue.indexOf(srchkey), 1);
    } else if (recentValue.length >= 3) {
      recentValue.shift();
    }
    recentValue.push(srchkey);
    Cookies.set("searches", recentValue.toString());
  }

  const handleSearchTopicSubmit = (data) => {
    let srchkey = data.searchkey;
    srchkey = srchkey.replace(/[?;//]/g, " ");
    setCookie(srchkey);
    let ge = data.searchgenus;
    if (
      document.querySelector(
        ".autosuggest .autosuggest-container ul li.selected"
      ) === null
    ) {
      if (searchkey !== "") {
        let path = "/topic-search/" + srchkey + "/" + ge;
        history.push(path);
      }
    } else {
      document
        .querySelector(".autosuggest .autosuggest-container ul li.selected a")
        .click();
    }
  };
  return (
    <div className="veterinarycondi">
      <Nav
        changeSearchkey={(e) => {
          changeSearchkey(e);
        }}
        optionList={optionList}
        onFormSubmit={(e) => {
          handleSearchTopicSubmit(e);
        }}
      />
      <Banner
        changeSearchkey={(e) => {
          changeSearchkey(e);
        }}
        optionList={optionList}
        onFormSubmit={(e) => {
          handleSearchTopicSubmit(e);
        }}
      />
    </div>
  );
};

export default SearchBanner;
